module.exports = __webpack_public_path__ + "img/monitoring-ship-yellow.d16ce63a.svg";